module.exports = __webpack_public_path__ + "img/close-sidebar-icon.a5590a83.svg";